import Archiwum from './Archiwum';
export default Archiwum;